import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axiosClient from "../../../axios-client";
import iziToast from "izitoast";
import "izitoast/dist/css/iziToast.min.css";

const AdminRegister = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const globalDiv = document.getElementById("globalDiv");
    if (globalDiv) {
      globalDiv.style.backgroundColor = "#ecf2ff";
      globalDiv.style.padding = "0px";
      return () => {
        globalDiv.style.backgroundColor = "";
        globalDiv.style.padding = "";
      };
    }
  }, []);

  useEffect(() => {
    const fullWidthNew = document.getElementById("fullWidthNew");
    if (fullWidthNew) {
      fullWidthNew.style.width = "100%";
      return () => {
        fullWidthNew.style.width = "";
      };
    }
  }, []);

  const [formData, setFormData] = useState({
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (formData.password !== formData.confirmPassword) {
      setError("Passwords do not match");
      iziToast.error({
        message: "Passwords do not match",
        position: "topCenter",
      });
      return;
    }

    if (formData.password.length < 6) {
      setError("Password must be at least 6 characters");
      iziToast.error({
        message: "Password must be at least 6 characters",
        position: "topCenter",
      });
      return;
    }

    setLoading(true);
    try {
      const response = await axiosClient.post("/admin/register", {
        username: formData.username,
        email: formData.email,
        password: formData.password,
      });

      if (response.data && (response.data.token || response.status === 201)) {
        iziToast.success({
          message: "Admin registered successfully! Please login.",
          position: "topCenter",
        });
        setTimeout(() => {
          navigate("/admin/login");
        }, 1500);
      } else {
        const msg = response.data?.message || "Registration failed";
        setError(msg);
        iziToast.error({
          message: msg,
          position: "topCenter",
        });
      }
    } catch (err) {
      const msg =
        err.response?.data?.message ||
        "An unexpected error occurred. Please try again.";
      setError(msg);
      iziToast.error({
        message: msg,
        position: "topCenter",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-login-blue shadow-custom-login rounded-2xl flex flex-wrap w-full">
      <div className="w-full lg:w-[50%]">
        <img
          src="/images/Mobilelogin.png"
          alt="Register Illustration"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="w-full lg:w-[50%] flex flex-col justify-center items-center shadow-lg bg-white py-8">
        <div className="flex items-center">
          <h1 className="font-montserrat font-semibold text-[36px] text-m-blue ml-3">
            Register Admin
          </h1>
        </div>
        <p className="font-poppins font-medium text-lg text-dark-gray">
          Create a new Admin account
        </p>

        {error && (
          <p className="text-red-500 font-poppins text-sm mt-2">{error}</p>
        )}

        <form className="w-full mt-4" onSubmit={handleSubmit}>
          {/* Username */}
          <div className="w-full lg:w-8/12 mx-auto mt-2">
            <label className="block font-poppins font-medium text-base mb-1">
              Username
            </label>
            <input
              type="text"
              name="username"
              className="w-full p-2 bg-login-input-blue rounded-[10px] border focus:outline-none font-normal font-poppins text-sm text-gray-3"
              value={formData.username}
              placeholder="Enter username"
              onChange={handleChange}
              required
            />
          </div>

          {/* Email */}
          <div className="w-full lg:w-8/12 mx-auto mt-3">
            <label className="block font-poppins font-medium text-base mb-1">
              Email Id
            </label>
            <input
              type="email"
              name="email"
              className="w-full p-2 bg-login-input-blue rounded-[10px] border focus:outline-none font-normal font-poppins text-sm text-gray-3"
              value={formData.email}
              placeholder="Enter your email"
              onChange={handleChange}
              required
            />
          </div>

          {/* Password */}
          <div className="w-full lg:w-8/12 mx-auto mt-3">
            <label className="block font-poppins font-medium text-base mb-1">
              Password
            </label>
            <div className="flex w-full relative border bg-login-input-blue rounded-[10px]">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                className="w-full p-2 bg-login-input-blue rounded-[10px] focus:outline-none font-normal font-poppins text-sm text-gray-3"
                placeholder="Enter password"
                value={formData.password}
                onChange={handleChange}
                required
              />
              <span className="absolute right-[10px] top-[6px]">
                <i
                  className={`cursor-pointer ${
                    showPassword ? "bi bi-eye-slash" : "bi bi-eye"
                  }`}
                  onClick={() => setShowPassword(!showPassword)}
                ></i>
              </span>
            </div>
          </div>

          {/* Confirm Password */}
          <div className="w-full lg:w-8/12 mx-auto mt-3">
            <label className="block font-poppins font-medium text-base mb-1">
              Confirm Password
            </label>
            <div className="flex w-full relative border bg-login-input-blue rounded-[10px]">
              <input
                type={showConfirmPassword ? "text" : "password"}
                name="confirmPassword"
                className="w-full p-2 bg-login-input-blue rounded-[10px] focus:outline-none font-normal font-poppins text-sm text-gray-3"
                placeholder="Re-enter password"
                value={formData.confirmPassword}
                onChange={handleChange}
                required
              />
              <span className="absolute right-[10px] top-[6px]">
                <i
                  className={`cursor-pointer ${
                    showConfirmPassword ? "bi bi-eye-slash" : "bi bi-eye"
                  }`}
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                ></i>
              </span>
            </div>
          </div>

          {/* Submit Button */}
          <div className="w-full lg:w-8/12 mx-auto pt-4">
            <button
              type="submit"
              disabled={loading}
              className="w-full py-[10px] rounded-[10px] text-center font-poppins text-lg font-medium bg-[#2e3192] text-white hover:opacity-90 transition-opacity disabled:opacity-50"
            >
              {loading ? "Registering..." : "Register"}
            </button>
          </div>

          {/* Link to Login */}
          <div className="w-full lg:w-8/12 mx-auto text-center mt-4">
            <p className="font-poppins text-sm text-dark-gray">
              Already have an Admin account?{" "}
              <Link
                to="/admin/login"
                className="text-[#2e3192] font-semibold underline ml-1"
              >
                Login here
              </Link>
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminRegister;

